import type { CryptoCode } from '@/constants/currencyCodes'

const coinGifs: Record<CryptoCode, string> = {
  BTC: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/bitcoin-optimised.gif',
  ETH: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/eth-optimised.gif',
  XAUT: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/gold-optimised.gif',
  USDT: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/usd-optimized.gif',
  KWDK: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/kwd-optimised.gif',
  SOL: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/sol-optimized.gif',
  AEDK: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/default-optimised.gif',
  SARK: 'https://storage.googleapis.com/kem-stage/animations%20optimised%202/default-optimised.gif',
}

export function getCoinGif(code: CryptoCode): string {
  return (
    coinGifs[code] ||
    'https://storage.googleapis.com/kem-stage/animations%20optimised%202/default-optimised.gif'
  )
}

export default getCoinGif
